/* eslint-disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".tile_1948861e{display:inline-block;position:relative;margin:4px}.smallTile_1948861e{width:138px;height:135px}.largeTile_1948861e{width:176px;height:171px}.tileFolder_1948861e{display:inline-block;margin:3px}.tileImage_1948861e{display:block}.activityBlock_1948861e{display:block;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}"}]);
export const tile = "tile_1948861e";
export const smallTile = "smallTile_1948861e";
export const largeTile = "largeTile_1948861e";
export const tileFolder = "tileFolder_1948861e";
export const tileImage = "tileImage_1948861e";
export const activityBlock = "activityBlock_1948861e";